// extracted by mini-css-extract-plugin
export default {"container":"documentVersionFlags_container__dRchu","textIcon":"documentVersionFlags_textIcon__J++dv"};